import { authenticatedFetch, backendUrl, jsonFetch } from "@/data/http"
import { setAuthTokens } from "@/data/store"
import type { LoginCredentials } from "@/model/LoginCredentials"
import type { LoginResponse } from "@/model/LoginResponse"
import type { SelfApiDto } from "@/model/Self"

export const logInWithEmailAndPassword = async ({
  email,
  password,
}: LoginCredentials): Promise<LoginResponse> => {
  const response = await jsonFetch<LoginResponse>(`${backendUrl}/v1/login`, {
    method: "POST",
    body: JSON.stringify({ email, password }),
  })
  setAuthTokens({ accessJwt: response.accessJwt, refreshJwt: response.refreshJwt })
  return response
}

export const getSelf = (): Promise<SelfApiDto> =>
  authenticatedFetch<SelfApiDto>(`${backendUrl}/v1/self`)

export const checkSignUpInvitation = (params: { token: string; userId: string }): Promise<void> =>
  jsonFetch<void>(`${backendUrl}/v1/invitation/check`, {
    method: "POST",
    body: JSON.stringify(params),
  })

export const acceptSignUpInvitation = async (params: {
  token: string
  userId: string
  password: string
}): Promise<LoginResponse> => {
  const response = await jsonFetch<LoginResponse>(`${backendUrl}/v1/invitation/accept`, {
    method: "POST",
    body: JSON.stringify(params),
  })
  setAuthTokens({ accessJwt: response.accessJwt, refreshJwt: response.refreshJwt })
  return response
}

export const sendForgotPasswordEmail = (params: { email: string }): Promise<void> =>
  jsonFetch<void>(`${backendUrl}/v1/password/forgot`, {
    method: "POST",
    body: JSON.stringify(params),
  })

export const checkResetPasswordToken = (params: { token: string; userId: string }): Promise<void> =>
  jsonFetch<void>(`${backendUrl}/v1/password/reset/check`, {
    method: "POST",
    body: JSON.stringify(params),
  })

export const resetPassword = async (params: {
  token: string
  userId: string
  password: string
}): Promise<LoginResponse> => {
  const response = await jsonFetch<LoginResponse>(`${backendUrl}/v1/password/reset`, {
    method: "POST",
    body: JSON.stringify(params),
  })
  // reset = auto-login (matches invitation accept)
  setAuthTokens({ accessJwt: response.accessJwt, refreshJwt: response.refreshJwt })
  return response
}

export type ResendInvitationApiDto = {
  email: string
}

export const resendInvitation = (params: ResendInvitationApiDto): Promise<void> =>
  jsonFetch<void>(`${backendUrl}/v1/invitation/resend`, {
    method: "POST",
    body: JSON.stringify(params),
  })
